module.exports = __webpack_public_path__ + "static/media/Application2.613a00a3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/application/Application2.svg
// module id = ./src/resources/images/application/Application2.svg
// module chunks = 0